import { getAPI, getAnalyticsAPI } from "./Networking";
import dayjs from "dayjs";
import { normalizeIds } from "../views/components/common/functions/formatDate";

export default class ReportDataAPI {
  getReportData = async (url: string, filters: any): Promise<any[]> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const date = dayjs(filters.date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (date) queryParams.append("date", date);

      if (filters.pm_adminids) {
        queryParams.append("pm_adminids", filters.pm_adminids);
      }

      if (filters.sales_admin_id) {
        queryParams.append("sales_admin_id", filters.sales_admin_id);
      }

      if (filters.closed_by) {
        queryParams.append("closed_by", filters.closed_by);
      }

      if (filters.admin_id) {
        queryParams.append("admin_id", filters.admin_id);
      }

      if (filters.product_id) {
        queryParams.append("product_id", filters.product_id);
      }

      if (filters.customer_id) {
        queryParams.append("customer_id", filters.customer_id);
      }

      if (filters.order_id) {
        queryParams.append("order_id", filters.order_id);
      }
      if (filters.order_type) {
        queryParams.append("order_type", filters.order_type);
      }
      if (filters.archived !== undefined) {
        if (filters.archived === 1 || filters.archived === "Archived") {
          queryParams.append("archived", "true");
        }
      } else {
        queryParams.append("archived", "false");
      }

      if (filters.vendor_id && filters.vendor_id.length > 0) {
        queryParams.append("vendor_id", filters.vendor_id);
      }

      if (filters.qc_time) {
        queryParams.append("qc_time", filters.qc_time);
      }

      if (filters.raised_by) {
        queryParams.append("raised_by", filters.raised_by);
      }

      if (filters.status_updated_by) {
        queryParams.append("status_updated_by", filters.status_updated_by);
      }

      if (filters.owner_ids && filters.owner_ids?.length > 0) {
        const normalized = normalizeIds(filters.owner_ids);
        if (normalized) {
          queryParams.append("owner_ids", normalized);
        }
      }

      if (filters.section) {
        queryParams.append("section", filters.section);
      }

      if (filters.status) {
        queryParams.append("status", filters.status);
      }

      if (filters.project_created) {
        queryParams.append("project_created", filters.project_created);
      }

      const response = await getAPI(`${url}?${queryParams.toString()}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
